const api = '/api/v1/u003_p_coms_controller.php';
import axios from 'axios';
export const coms_repository =  {
    get(sellId){
        return  axios.get(`${api}?SELL_ID=${sellId}`);
    },
    upd(data){
        return  axios.post(api, data);
    }
};

